import { useParams } from 'react-router-dom';
import { useSendAnalytics } from 'src/components/AnalyticsProvider/useSendAnalytics';
import { IInputProps } from 'src/components/Input/Input';
import { sdk } from 'src/utilities/sdk';
import { ROLES } from 'src/types/Employee';

export interface Employee {
  first_name: string;
  last_name: string;
  email: string;
  role?: ROLES;
}

export interface EmployeeFormInputProps extends IInputProps {
  name: keyof Employee;
  validation?: (value: string) => string | boolean;
}

export const emptyEmployeeFormFields: Employee = {
  first_name: '',
  last_name: '',
  email: '',
};

export enum EmployeeFormLabel {
  first_name = 'First name',
  last_name = 'Last name',
  email = 'Email',
}

export interface EmployeeValidationErrors {
  message_key: string;
  property: keyof Employee;
}

export interface EmployeeValidationResponse {
  already_exists: boolean;
  validation_errors?: EmployeeValidationErrors[];
}

export const getEmployeeValidation = async (
  corpId: string,
  payload: Employee
): Promise<EmployeeValidationResponse> => {
  return sdk.http.post(`/corp-admin/${corpId}/diners/validate`, {
    ...payload,
    role: ROLES.DINER,
  });
};

export interface UseEmployeeFormAnalytics {
  sendAnalyticsOnSuccess: () => void;
  sendAnalyticsOnValidationErrors: (analyticsErrorsList: string) => void;
  sendAnalyticsOnEmailAlreadyExistsError: () => void;
}

export const useEmployeeFormAnalytics = (): UseEmployeeFormAnalytics => {
  const { locId } = useParams<{ locId: string }>();

  const { sendAnalytics } = useSendAnalytics({
    eventcategory: 'self-service management tool_people',
    eventaction: locId ? 'loc_soft_add_people' : 'soft add people',
    eventlabel: '',
  });

  function sendAnalyticsOnSuccess() {
    sendAnalytics({ eventlabel: 'success' });
  }
  function sendAnalyticsOnValidationErrors(analyticsErrorsList: string) {
    sendAnalytics({ eventlabel: analyticsErrorsList });
  }
  function sendAnalyticsOnEmailAlreadyExistsError() {
    sendAnalytics({ eventlabel: 'Person already exists' });
  }

  return {
    sendAnalyticsOnSuccess,
    sendAnalyticsOnEmailAlreadyExistsError,
    sendAnalyticsOnValidationErrors,
  };
};
